import PropTypes from 'prop-types'
import React from 'react'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import TextBody from 'components/TextBody'

function InputRadioLabel ({ value }) {
  return (
    <div style={{ paddingRight: STYLES_PADDING.MEDIUM }}>
      <TextBody>
        {value}
      </TextBody>
    </div>
  )
}

InputRadioLabel.propTypes = {
  value: PropTypes.string.isRequired
}

export default InputRadioLabel
